import React from 'react';
import { useTheme } from '@material-ui/core/styles';
export const Table = ({
  AgGridReact,
  columnDefs,
  frameworkComponents,
  gridOptions,
  rowData,
  onCellValueChanged,
  onCellClicked,
  onGridReady,
  id,
  loadingOverlayComponent,
  rowHeight
}) => {
  const {
    props: {
      grid: gridTheme
    }
  } = useTheme(); // TODO check for bad data w columnDefs and rowData and add TableProps

  return /*#__PURE__*/React.createElement("div", {
    style: {
      height: '100%',
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(AgGridReact, {
    key: id,
    frameworkComponents: frameworkComponents,
    columnDefs: columnDefs,
    rowData: rowData,
    gridOptions: gridOptions,
    onGridReady: onGridReady,
    rowHeight: rowHeight || gridTheme.rowHeight,
    headerHeight: gridTheme.headerHeight,
    onCellValueChanged: onCellValueChanged,
    onCellClicked: onCellClicked,
    loadingOverlayComponent: loadingOverlayComponent
  }));
};
export default Table;